export default __webpack_public_path__ + "media/images/svg/x-icon-6e4679a615a49a0a3196a0d22f3c630b.svg";